import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Store } from "../types/modules/store.type";

export interface StoreState {
  accessToken: string;
  store: Store;
}

const initialState: StoreState = {
  accessToken: "",
  store: {} as Store,
};

const storeSlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    loginStore(
      state,
      action: PayloadAction<{
        accessToken: string;
        store: Store;
      }>
    ) {
      state.accessToken = action.payload.accessToken;
      state.store = action.payload.store;
    },
    logoutStore(state) {
      state.accessToken = "";
      state.store = {} as Store;
    },
  },
});

export const { loginStore, logoutStore } =
  storeSlice.actions;
export default storeSlice.reducer;
